import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import { Grid, TextField, Select, FormControl, InputLabel, MenuItem, DialogTitle, Dialog } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import inputComponentMask from "lib/inputMask";
import { Field } from "formik";
import { UnstyledDateField } from "components/Global/Fields/Date";

import SectionHeader from "./SectionHeader";
import ConfigItemSelect from "./ConfigItemSelect";
import PercentInput from "./PercentInput";
import StandardNumberInput from "./StandardNumberInput";

const styles = theme => ({
  inputField: {
    borderBottom: "1px solid #2196F3"

  },
  labelRoot: {
    fontSize: "17px"
  }
});

const DateFieldWrapper = styled.div`
 & div:first-child {
   width:100%;
 }
 & label {
  font-size:17px;
}
 &&&&& div div::before {
   border-bottom: 1px solid #2196F3;
 }
`;

class PropertyHistoryInfo extends React.Component {
  render() {
    const { handleChange, handleBlur, values } = this.props; // formik props
    const { classes } = this.props;

    return (
      <div>
        <SectionHeader>Property History</SectionHeader>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <DateFieldWrapper>
              <UnstyledDateField
                label="Purchase Date"
                name="purchaseDate"
                id="purchaseDateField"
                value={values.purchaseDate}
                clearable
              />
            </DateFieldWrapper>
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Purchase Price"
              type="text"
              name="purchasePrice"
              id="purchasePriceField"
              value={values.purchasePrice || ""}
              onChange={handleChange}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}
              InputProps={{ classes: {
                input: classes.inputField
              },

              disableUnderline: true,
              inputComponent: inputComponentMask({
                mask: "currency"
              }) }}
            />
          </Grid>
          <Grid item xs={3}>
            <StandardNumberInput
              fullWidth
              classes={classes}
              label="CapEx Improvements"
              id="capExImprovementsField"
              fieldName="capExImprovements"
              values={values}
              handleChange={handleChange}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={3}>
            <TextField
              InputProps={{
                classes: {
                  input: classes.inputField
                },
                disableUnderline: true
              }}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}
              label="Year Built"
              type="number"
              name="yearBuilt"
              id="yearBuildField"
              value={values.yearBuilt}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              InputProps={{
                classes: {
                  input: classes.inputField
                },
                disableUnderline: true
              }}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}
              label="Year Renovated"
              id="yearRenovatedField"
              type="number"
              name="yearRenovated"
              value={values.yearRenovated}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(PropertyHistoryInfo);
